<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Job Lists" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <h6 class="card-title mb-0 flex-grow-1">Search Jobs</h6>
                    <div class="flex-shrink-0">
                        <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#CreateJobModal" (click)="openModal(createJobModal)"><i class="ri-add-line align-bottom me-1"></i> Create
                            New
                            Job</button>
                    </div>
                </div>

                <div class="row mt-3 gy-3">
                    <div class="col-xxl-10 col-md-6">
                        <div class="search-box">
                            <input type="text" class="form-control search bg-light border-light" id="searchJob" autocomplete="off" placeholder="Search for jobs or companies..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-xxl-2 col-md-6">
                        <div class="input-light">
                            <select class="form-control choices__inner" data-choices data-choices-search-false name="choices-single-default" id="idStatus">
                                <option value="All">All Selected</option>
                                <option value="Newest" selected>Newest</option>
                                <option value="Popluar">Popluar</option>
                                <option value="Oldest">Oldest</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xl-12 d-none" id="found-job-alert">
                        <div class="alert alert-success mb-0 text-center" role="alert">
                            <strong id="total-result">253</strong> jobs found
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xxl-9">
        <!-- <div id="job-list"></div> -->
        @for (list of joblists; track $index) {
        <div class="card joblist-card">
            <div class="card-body">
                <div class="d-flex mb-4">
                    <div class="avatar-sm">
                        <div class="avatar-title bg-light rounded">
                            <img src="{{list.logo}}" alt="" class="avatar-xxs companyLogo-img">
                        </div>
                    </div>
                    <div class="ms-3 flex-grow-1">
                        <!-- <img src="{{list.coverimage}}" alt="" class="d-none cover-img"> -->
                        <a href="javascript:void(0);">
                            <h5 class="job-title">{{list.title}}</h5>
                        </a>
                        <p class="company-name text-muted mb-0"> {{list.companyname}}</p>
                    </div>
                    <div>
                        <button type="button" class="btn btn-ghost-primary btn-icon custom-toggle" data-bs-toggle="button">
                            <span class="icon-on"><i class="ri-bookmark-line"></i></span>
                            <span class="icon-off"><i class="ri-bookmark-fill"></i></span>
                        </button>
                    </div>
                </div>
                <p class="text-muted job-description">{{list.content}}</p>
                <div>
                    @for (tag of list.tags; track $index) {
                    <span class="badge bg-primary-subtle text-primary me-1">{{tag}}</span>
                    }
                </div>
            </div>
            <div class="card-footer border-top-dashed">
                <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div><i class="ri-briefcase-2-line align-bottom mx-1"></i> <span class="job-type">
                            {{list.type}}</span>
                    </div>
                    <div class="d-none"><span class="job-experience">{{list.experience}}</span></div>
                    <div><i class="ri-map-pin-2-line align-bottom mx-1"></i> <span class="job-location">
                            {{list.location}}</span></div>
                    <div><i class="ri-user-3-line align-bottom mx-1"></i> {{list.applied}} Applied</div>
                    <div><i class="ri-time-line align-bottom mx-1"></i> <span class="job-postdate"> {{list.date}}</span>
                    </div>
                    <div><a href="javascript:void(0);" class="btn btn-primary viewjob-list" (click)="viewmore($index)">View
                            More <i class="ri-arrow-right-line align-bottom ms-1"></i></a></div>
                </div>
            </div>
        </div>
        }
        <!-- pagination -->
        @if(jobdetail){
        <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="alljoblist.length" [(page)]="service.page" [pageSize]="service.pageSize" (pageChange)="changePage()" aria-label="Custom pagination">
            <ng-template ngbPaginationPrevious let-page let-pages="pages">
                <i class="ci-arrow-left me-2"></i>
                Prev
            </ng-template>
            <ng-template ngbPaginationNext>
                Next
                <i class="ci-arrow-right ms-2"></i>
            </ng-template>
        </ngb-pagination>
        }
    </div>
    <!--end col-->
    <div class="col-xxl-3">
        @if (jobdetail) {
        <div class="card job-list-view-card overflow-hidden" id="job-overview">
            <img src="{{jobdetail.coverimage}}" alt="" id="cover-img" class="img-fluid background object-fit-cover">
            <div class="card-body">
                <div class="avatar-md mt-n5">
                    <div class="avatar-title bg-light rounded-circle">
                        <img src="{{jobdetail.logo}}" alt="" class="avatar-xs view-companylogo">
                    </div>
                </div>
                <div class="mt-3">
                    <h5 class="view-title">{{jobdetail.title}}</h5>
                    <div class="hstack gap-3 mb-3">
                        <span class="text-muted"><i class="ri-building-line me-1 align-bottom"></i> <span class="view-companyname">{{jobdetail.companyname}}</span></span>
                        <span class="text-muted"><i class="ri-map-pin-2-line me-1 align-bottom"></i> <span class="view-location">{{jobdetail.location}}</span></span>
                    </div>
                    <p class="text-muted view-desc">{{jobdetail.content}}</p>
                    <div class="py-3 border border-dashed border-start-0 border-end-0 mt-4">
                        <div class="row">
                            <div class="col-lg-4 col-sm-6">
                                <div>
                                    <p class="mb-2 text-uppercase fw-medium fs-12 text-muted">Job Type</p>
                                    <h5 class="fs-14 mb-0 view-type">{{jobdetail.type}}</h5>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <div>
                                    <p class="mb-2 text-uppercase fw-medium fs-12 text-muted">Post Date</p>
                                    <h5 class="fs-14 mb-0 view-postdate">{{jobdetail.date}}</h5>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <div>
                                    <p class="mb-2 text-uppercase fw-medium fs-12 text-muted">Experience</p>
                                    <h5 class="fs-14 mb-0 view-experience">{{jobdetail.experience}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <h5 class="mb-3">Application Summary</h5>

                    <div>
                        <div id="simple_dount_chart" class="apex-charts" dir="ltr">
                            <apx-chart [series]="portfolioChart.series" [labels]="portfolioChart.labels" [chart]="portfolioChart.chart" [plotOptions]="portfolioChart.plotOptions" [dataLabels]="portfolioChart.dataLabels" [legend]="portfolioChart.legend" [yaxis]="portfolioChart.yaxis" [stroke]="portfolioChart.stroke" [colors]="portfolioChart.colors" dir="ltr"></apx-chart>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <button type="button" class="btn btn-success w-100">Apply Now</button>
                </div>
            </div>
        </div>
        }
    </div>
    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<!-- Create Model -->
<ng-template #createJobModal let-modal>
    <div class="modal-content border-0">
        <form id="createjob-form" autocomplete="off" class="needs-validation" (ngSubmit)="createJob()" [formGroup]="jobData" novalidate>
            <div class="modal-body">
                <input type="hidden" id="id-field" formControlName="id" />
                <div class="row g-3">
                    <div class="col-lg-12">
                        <div class="px-1 pt-1">
                            <div class="modal-team-cover position-relative mb-0 mt-n4 mx-n4 rounded-top overflow-hidden">
                                <img src="assets/images/small/img-9.jpg" alt="" id="modal-cover-img" class="img-fluid">

                                <div class="d-flex position-absolute start-0 end-0 top-0 p-3">
                                    <div class="flex-grow-1">
                                        <h5 class="modal-title text-white" id="exampleModalLabel">Create New Job</h5>
                                    </div>
                                    <div class="flex-shrink-0">
                                        <div class="d-flex gap-3 align-items-center">
                                            <div>
                                                <label for="cover-image-input" class="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" ngbTooltip="Select Cover Image">
                                                    <div class="avatar-xs">
                                                        <div class="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                                            <i class="ri-image-fill"></i>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input class="form-control d-none" value="" id="cover-image-input" type="file" accept="image/png, image/gif, image/jpeg" (change)="coverChange($event)">
                                            </div>
                                            <button type="button" class="btn-close btn-close-white" id="close-jobListModal" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('close click')"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mb-4 mt-n5 pt-2">
                            <div class="position-relative d-inline-block">
                                <div class="position-absolute bottom-0 end-0">
                                    <label for="companylogo-image-input" class="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" ngbTooltip="Select Image">
                                        <div class="avatar-xs cursor-pointer">
                                            <div class="avatar-title bg-light border rounded-circle text-muted">
                                                <i class="ri-image-fill"></i>
                                            </div>
                                        </div>
                                    </label>
                                    <input class="form-control d-none" value="" id="companylogo-image-input" type="file" accept="image/png, image/gif, image/jpeg" (change)="fileChange($event)">
                                </div>
                                <div class="avatar-lg p-1">
                                    <div class="avatar-title bg-light rounded-circle">
                                        <img src="assets/images/users/multi-user.jpg" id="companylogo-img" class="avatar-md rounded-circle object-fit-cover" />
                                    </div>
                                </div>
                            </div>
                            <h5 class="fs-13 mt-3">Company Logo</h5>
                        </div>
                        <div>
                            <label for="jobtitle-field" class="form-label">Job Title</label>
                            <input type="text" id="jobtitle-field" class="form-control" placeholder="Enter job title" required formControlName="jobtitle" [ngClass]="{ 'is-invalid': submitted && form['jobtitle'].errors }" />
                            <div class="invalid-feedback">Please enter a job title.</div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div>
                            <label for="companyname-field" class="form-label">Company Name</label>
                            <input type="text" id="companyname-field" class="form-control" placeholder="Enter company name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && form['name'].errors }" />
                            <div class="invalid-feedback">Please enter a company name.</div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div>
                            <label for="job_type-field" class="form-label">Job Type</label>
                            <select class="form-select" id="job_type-field" required formControlName="jobtype" [ngClass]="{ 'is-invalid': submitted && form['jobtype'].errors }">
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Freelance">Freelance</option>
                                <option value="Internship">Internship</option>
                            </select>
                            <div class="invalid-feedback">Please select a job type.</div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div>
                            <label for="experience-field" class="form-label">Experience</label>
                            <input type="text" id="experience-field" class="form-control" placeholder="Enter experience" required formControlName="experience" [ngClass]="{ 'is-invalid': submitted && form['experience'].errors }" />
                            <div class="invalid-feedback">Please enter a job experience.</div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div>
                            <label for="location-field" class="form-label">Location</label>
                            <input type="text" id="location-field" class="form-control" placeholder="Enter location" required formControlName="location" [ngClass]="{ 'is-invalid': submitted && form['location'].errors }" />
                            <div class="invalid-feedback">Please enter a location.</div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div>
                            <label for="Salary-field" class="form-label">Salary</label>
                            <input type="number" id="Salary-field" class="form-control" placeholder="Enter salary" formControlName="salary" />
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div>
                            <label for="website-field" class="form-label">Tags</label>
                            <input class="form-control" id="taginput-choices" data-choices data-choices-text-unique-true type="text" value="Design, Remote" formControlName="tags" />
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div>
                            <label for="description-field" class="form-label">Description</label>
                            <textarea class="form-control" id="description-field" rows="3" placeholder="Enter description" required formControlName="description" [ngClass]="{ 'is-invalid': submitted && form['description'].errors }"></textarea>
                            <div class="invalid-feedback">Please enter a description.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="hstack gap-2 justify-content-end">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="modal.dismiss('close click')">Close</button>
                    <button type="submit" class="btn btn-success" id="add-btn">Add Job</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!--end add modal-->